import { render, staticRenderFns } from "./TodoListButtonDelete.vue?vue&type=template&id=03ea3340&scoped=true&"
import script from "./TodoListButtonDelete.vue?vue&type=script&lang=js&"
export * from "./TodoListButtonDelete.vue?vue&type=script&lang=js&"
import style0 from "./TodoListButtonDelete.vue?vue&type=style&index=0&id=03ea3340&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ea3340",
  null
  
)

export default component.exports